import React from 'react';

import { coreTranslations, doNotContactTranslations, globalSearchTranslations } from 'translations';
import featureService from '@services/feature.service';
import LocalStorageUtility from 'common/utility/localStorageUtility';

import {
    BrandingImage,
    DoNotContactImage,
    IntegrationsImage,
    ModalityImage,
    PermissionsImage,
    SecurityImage,
    SelfRegImage,
    TravelImage
} from '@components/GlobalSearch/Images/index';
import { permissionsConfig } from '../PermissionsPageConfig/PermissionsPageConfig';
import { isMfaAccountSettingsVisible } from '../SecurityPage/tilesConfig';
import PermissionService from '@services/permission.service';

export const isSecurityPageVisible = access => isMfaAccountSettingsVisible(access);

const { permissions } = new PermissionService();


export const tilesConfig = [
    {
        title: coreTranslations.ng_core_integrations,
        description: coreTranslations.ng_core_integrationsSocialMediaDescription,
        path: '/integrations',
        icon: <IntegrationsImage color="primary" />,
        visible: access => access.canManageIntegrations() && access.canViewIntegration()
    },
    {
        title: coreTranslations.ng_core_selfReg,
        description: coreTranslations.ng_core_selfRegDescription,
        path: '/account-portal',
        icon: <SelfRegImage color="primary" />,
        visible: access => {return access.canManageSelfRegPortals()}
    },
    {
        title: globalSearchTranslations.ng_globalSearch_permissions,
        description: coreTranslations.ng_core_permissionsDescription,
        path: '/permissions',
        icon: <PermissionsImage color="primary" />,
        visible: access => permissionsConfig.some(i => i.visible(access)) // Do not show the tile if all sub-tiles are invisible.
    },
    {
        title: coreTranslations.ng_core_branding,
        description: coreTranslations.ng_core_brandingDescription,
        path: '/branding',
        icon: <BrandingImage color="primary" />,
        visible: access => access.canViewCustomVerbiage() || access.canViewExternalLinks()
    },
    {
        title: doNotContactTranslations.ng_doNotContact_listTitle,
        description: doNotContactTranslations.ng_doNotContact_subtitle,
        path: '/donotcontact',
        icon: <DoNotContactImage color="primary" />,
        visible: access => access.canManageDoNotContact() && featureService.getFeature('doNotContact')
    },
    {
        title: coreTranslations.ng_core_security,
        description: coreTranslations.ng_core_securityDescription,
        path: '/security',
        icon: <SecurityImage color="primary" />,
        visible: access => isSecurityPageVisible(access)
    },
    {
        title: coreTranslations.ng_core_modalityConfig,
        description: coreTranslations.ng_core_modalityDescription,
        path: '/modality',
        icon: <ModalityImage color="primary" />,
        visible: access => access.canOrganizationAdmin()
    },
    {
        title: coreTranslations.ng_core_travel,
        description: coreTranslations.ng_core_travelDescription,
        path: '/travel',
        icon: <TravelImage color="primary" />,
        visible: () => permissions.canManageRiskIntelligence() && !!LocalStorageUtility.getData('riConfigurationInfo')?.travel
    }
];
